import {
  Alert,
  AlertTitle,
  IconButton,
  Snackbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useBoundStore } from "useStore";

export default function AppAlert() {
  const alertState = useBoundStore((state) => state.alertState);
  const setAlertState = useBoundStore((state) => state.setAlertState);

  const handleClose = () => {
    setAlertState({
      open: false,
      message: "",
      title: "",
      errors: [],
      severity: "info",
    });
  };

  return (
    <Snackbar
      open={alertState.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ width: "100%" }}
        severity={alertState.severity}
      >
        <AlertTitle>{alertState.title}</AlertTitle>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: "pre-line" }}
        >
          {alertState.message}
        </Typography>

        {alertState.errors?.length > 0 && (
          <ul>
            {alertState.errors.map((error, index) => (
              <Typography
                component="li"
                key={index}
                variant="body2"
                color="text.secondary"
              >
                {error}
              </Typography>
            ))}
          </ul>
        )}
      </Alert>
    </Snackbar>
  );
}
